"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OriginCountDatasetStruct = exports.TypeCountDatasetStruct = exports.ConfirmationCountDatasetStruct = exports.StatusCountDatasetStruct = exports.AvgProcessingTimeDatasetStruct = exports.AvgWaitingTimeDatasetStruct = exports.TicketCountDatasetStruct = exports.TicketCountRowStruct = void 0;
const superstruct_1 = require("superstruct");
exports.TicketCountRowStruct = (0, superstruct_1.object)({
    date: (0, superstruct_1.string)(),
    service: (0, superstruct_1.string)(),
    count: (0, superstruct_1.number)(),
});
exports.TicketCountDatasetStruct = (0, superstruct_1.object)({
    total: (0, superstruct_1.number)(),
    data: (0, superstruct_1.array)(exports.TicketCountRowStruct),
});
exports.AvgWaitingTimeDatasetStruct = (0, superstruct_1.object)({
    avgWaitingTime: (0, superstruct_1.number)(),
});
exports.AvgProcessingTimeDatasetStruct = (0, superstruct_1.object)({
    avgProcessingTime: (0, superstruct_1.number)(),
});
exports.StatusCountDatasetStruct = (0, superstruct_1.object)({
    processed: (0, superstruct_1.number)(),
    invited: (0, superstruct_1.number)(),
    queued: (0, superstruct_1.number)(),
    cancelled: (0, superstruct_1.number)(),
    noShow: (0, superstruct_1.number)(),
});
exports.ConfirmationCountDatasetStruct = (0, superstruct_1.object)({
    confirmed: (0, superstruct_1.number)(),
    pending: (0, superstruct_1.number)(),
    rejected: (0, superstruct_1.number)(),
});
exports.TypeCountDatasetStruct = (0, superstruct_1.object)({
    appointments: (0, superstruct_1.number)(),
    liveQueue: (0, superstruct_1.number)(),
});
exports.OriginCountDatasetStruct = (0, superstruct_1.object)({
    counter: (0, superstruct_1.number)(),
    visitor: (0, superstruct_1.number)(),
});
//# sourceMappingURL=statistics.js.map